<p class="copyright">
  {{'general.texts.copyright' | translate}}
</p>
